import { cn } from '@massilia/ui'
import { type ReactNode } from 'react'

interface StepCardProps {
  className?: string
  children: ReactNode
  step: number
  subtitle?: string
  title: string
}

export function StepCard({ className, children, step, subtitle, title }: StepCardProps) {
  return (
    <div
      className={cn(
        'border-brand-500 flex w-full flex-col gap-4 rounded-2xl border-2 bg-white p-5 shadow-sm',
        className
      )}
    >
      <div className="flex items-start gap-3">
        <div
          aria-hidden
          className="bg-brand-600 mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white"
        >
          {step}
        </div>
        <div className="flex flex-col gap-1">
          <div className="text-gray-light-900 text-base font-semibold leading-none">{title}</div>
          {subtitle && (
            <div className="text-gray-light-700 text-xs font-medium">{subtitle}</div>
          )}
        </div>
      </div>
      {children}
    </div>
  )
}
